import { useEffect } from "react";
import { useThemeMode } from "../store/ui-preferences.store";

/**
 * Reads the resolved theme mode and applies it to <html>. `color-scheme` picks the light-dark() arm
 * of every palette token in @noa/theme/scheme.css and keeps native form controls in sync;
 * `data-theme` drives the dark-only overrides. Web-only — mobile applies its theme
 * via Appearance/NativeWind instead.
 */
export function useApplyThemeMode() {
  const themeMode = useThemeMode();

  useEffect(() => {
    const el = document.documentElement;
    el.dataset.theme = themeMode;
    el.style.colorScheme = themeMode;
  }, [themeMode]);
}
